// Requires all fonts in current folder
const requireAllFonts = require.context(
    './',
    true,
    /\.(woff(2)?|ttf|eot)$/i
);
requireAllFonts.keys().forEach(requireAllFonts);
